import { useEffect, useRef } from "react";

/**
 * Create a new interval that loops over its function
 *
 * @param   {function}  callback:     The callback that has to run after each delay
 * @param   {number}    delay:        The delay in ms
 * @param   {boolean}   condition:    Condition on which the interval should be initialized
 */
export default function useInterval(callback, delay, condition = true) {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function tick() {
      savedCallback.current();
    }

    if (delay !== null && condition) {
      let id = setInterval(tick, delay);

      return () => clearInterval(id);
    }
  }, [delay, condition]);
}
